import Summary from './Summary';
import NewPost from './NewPost/NewPost';
import PostList from './PostList/PostList';

export {
    NewPost,
    Summary,
    PostList
}